module.exports = __webpack_public_path__ + "img/tunisia.5eb61ea.webp";